import { DateTime } from 'luxon';

/**
 * Janela comercial de vigência do Capital Global.
 *
 * O início da vigência precisa cair dentro de uma janela de 30 dias contada a
 * partir de hoje, com hoje valendo como dia 1 — logo o teto é `hoje + 29 dias`
 * (ex.: em 01/08/2026 o máximo permitido é 30/08/2026). O piso é HOJE: o
 * Capital Global aceita vigência começando no mesmo dia da proposta — a janela
 * fecha exatamente 30 dias, de hoje até hoje + 29.
 */
export const CAPITAL_GLOBAL_EFFECTIVE_WINDOW_DAYS = 30;

function today() {
  return DateTime.now().startOf('day');
}

/** Menor início de vigência aceito (hoje), em ISO `yyyy-MM-dd`. */
export function capitalGlobalMinEffectiveStartDate(): string {
  return today().toISODate() || '';
}

/** Maior início de vigência aceito (hoje + 29 dias), em ISO `yyyy-MM-dd`. */
export function capitalGlobalMaxEffectiveStartDate(): string {
  return (
    today()
      .plus({ days: CAPITAL_GLOBAL_EFFECTIVE_WINDOW_DAYS - 1 })
      .toISODate() || ''
  );
}

/** Mensagem de bloqueio quando a data escolhida estoura a janela de 30 dias. */
export function capitalGlobalEffectiveStartDateWindowMessage(): string {
  const max = DateTime.fromISO(capitalGlobalMaxEffectiveStartDate());
  return `A vigência não pode ultrapassar ${CAPITAL_GLOBAL_EFFECTIVE_WINDOW_DAYS} dias a partir de hoje (máximo ${max.toFormat('dd/MM/yyyy')})`;
}

/** `true` quando a data está entre hoje e o teto da janela de 30 dias. */
export function isCapitalGlobalEffectiveStartDateWithinWindow(
  value?: string
): boolean {
  const date = DateTime.fromISO((value || '').split('T')[0] || '');
  if (!date.isValid) return false;

  const startOfDay = date.startOf('day');
  return (
    startOfDay >= DateTime.fromISO(capitalGlobalMinEffectiveStartDate()) &&
    startOfDay <= DateTime.fromISO(capitalGlobalMaxEffectiveStartDate())
  );
}

/** `true` quando a data existe e passa do teto da janela de 30 dias. */
export function isAfterCapitalGlobalEffectiveWindow(value?: string): boolean {
  const date = DateTime.fromISO((value || '').split('T')[0] || '');
  if (!date.isValid) return false;

  return (
    date.startOf('day') > DateTime.fromISO(capitalGlobalMaxEffectiveStartDate())
  );
}
